// Angular
import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
// CRUD
import { QueryParamsModel } from '../models/query-models/query-params.model';

@Injectable()
export class HttpUtilsService {
  convertToHttpParams(queryParams: QueryParamsModel): HttpParams {
    const params = {} as any;
    Object.keys(queryParams.filter).forEach((key) => {
      params[key] = queryParams.filter[key];
    });

    return new HttpParams({ fromObject: params });
  }

  /**
   * Prepare query http params
   * @param queryParams: QueryParamsModel
   */
  getFindHTTPParams(
    queryParams: QueryParamsModel,
    customParams = {} as any
  ): HttpParams {
    const params = customParams;
    Object.keys(queryParams.filter).forEach((key) => {
      params[key] = queryParams.filter[key];
    });



    if (queryParams.filter['createdAt']) {
      params[`createdAt[after]`] = queryParams.filter['createdAt']['after'];
      params[`createdAt[before]`] = queryParams.filter['createdAt']['before'];

      delete params['createdAt'];
    }

    if (queryParams.filter['orderOwner.createdAt']) {
      params[`orderOwner.createdAt[after]`] = queryParams.filter['orderOwner.createdAt']['after'];
      params[`orderOwner.createdAt[before]`] = queryParams.filter['orderOwner.createdAt']['before'];

      delete params['orderOwner.createdAt'];
    }

    if (queryParams.filter['startDateAt']) {
      params[`startDateAt[after]`] = queryParams.filter['startDateAt']['after'];
      params[`startDateAt[before]`] = queryParams.filter['startDateAt']['before'];

      delete params['startDateAt'];
    }

    // if (queryParams.filter['dueDate']) {
    //   params[`dueDate[after]`] = queryParams.filter['dueDate']['after'];
    //   params[`dueDate[before]`] = queryParams.filter['dueDate']['before'];

    //   delete params['dueDate'];
    // }

    params[`order[${queryParams.sortField}]`] = queryParams.sortOrder;
    params['page'] = queryParams.pageNumber.toString();
    params['pageSize'] = queryParams.pageSize.toString();

    if (queryParams.filter.pagination === false) {
      delete params['page'];
      delete params['pageSize'];
    }

    return new HttpParams({ fromObject: params });
  }

  getFindHTTPParamsCustom(query: any): HttpParams {
    let params: HttpParams = new HttpParams();
    for (const key of Object.keys(query)) {
      if (query[key]) {
        if (query[key] instanceof Array) {
          query[key].forEach((item: any) => {
            params = params.append(`${key.toString()}[]`, item);
          });
        } else {
          params = params.append(key.toString(), query[key]);
        }
      }
    }
    return params;
  }
}
